import { render, staticRenderFns } from "./ExamResult.vue?vue&type=template&id=252ce668&"
import script from "./ExamResult.vue?vue&type=script&lang=js&"
export * from "./ExamResult.vue?vue&type=script&lang=js&"
import style0 from "./ExamResult.vue?vue&type=style&index=0&id=252ce668&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports